import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'amfe-flexible'
import "./assets/font_2182572_6mek5im3ka6/iconfont.css"
import Vant from 'vant'
import 'vant/lib/index.css'
import '@style/common.scss'
import moment from 'moment'
import { getRequest, postRequest, deleteRequest, putRequest } from '@/Api'
import VConsole from 'vconsole'

if (process.env.NODE_ENV === 'development') {
   const vc = new VConsole()
} 

Vue.prototype.$moment = moment;
moment.locale('zh-cn')
Vue.prototype.fetchget = getRequest;
Vue.prototype.fetchpost = postRequest;
Vue.prototype.fetchdelete = deleteRequest;
Vue.prototype.fetchput = putRequest;
// Vue.use(JsBarcode);
Vue.use(Vant);
Vue.config.productionTip = false
Vue.config.ignoredElements = ['wx-open-launch-weapp']
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
//防抖，两秒内点击只触发一次
Vue.directive('debounce', {
    inserted(el, binding, vnode) {
        let timer = {}
        el.addEventListener('click', () => {
            if (timer) {
                clearTimeout(timer)
            }
            timer = setTimeout(() => {
                binding.value()
            }, 2000)
        })
    }
})
